import { Grid, Typography } from "@mui/material";
import { OnboardingStepper } from "../components/OnboardingStepper.tsx";
import { onboardingSteps } from "../data/onboardingSteps.ts";
import { HeroHeader } from "../components/HeroHeader.tsx";
import { LabsCard } from "../components/LabsCard.tsx";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Button from "@mui/material/Button";
import { Link, Link as RouterLink } from "react-router";
import { trackEvent } from "../util/analytics.ts";
import { EventCategory } from "@labs/shared/types/EventCategory.ts";

const Scope3Info = () => (
  <Grid container rowSpacing={4} columnSpacing={2}>
    <OnboardingStepper activeStep={2} steps={onboardingSteps} />
    <Grid size={12}>
      <HeroHeader
        title="Scope 3: Indirect Emissions"
        description="No matter where you are in your scope 3 journey, we have the resources you need to get the job done."
      />
    </Grid>
    <Grid size={{ xs: 12, md: 6 }}>
      <LabsCard>
        <Typography variant="h6" color={"primary.dark"} textAlign={"center"}>
          Strategies
        </Typography>
        <List
          sx={{
            listStyleType: "disc",
            listStylePosition: "inside",
            "& .MuiListItem-root": {
              display: "list-item",
            },
          }}
        >
          <ListItem>
            Understand your product footprint(s) using actionable lifecycle
            assessments.
          </ListItem>
          <ListItem>
            Align your supply chain with your decarbonization goals, ensuring
            that your vendors and partners also contribute to your
            sustainability objectives.
          </ListItem>
          <ListItem>
            Strengthen supplier relationships by collaborating on sustainability
            initiatives, reducing emissions and improving the environmental
            impact across your value chain.
          </ListItem>
          <ListItem>
            Demonstrate leadership by promoting sustainable practices throughout
            your supply chain, contributing to a broader industry shift toward
            decarbonization.
          </ListItem>
        </List>
        <Button
          component={RouterLink}
          to="/contact-us"
          variant="contained"
          sx={{
            alignSelf: "center",
          }}
          onClick={() =>
            trackEvent(
              EventCategory.LeadGen,
              "Clicked Link",
              window.location.href,
            )
          }
        >
          Get In Touch
        </Button>
      </LabsCard>
    </Grid>
    <Grid size={{ xs: 12, md: 6 }}>
      <LabsCard>
        <Typography variant={"h6"} color={"primary.dark"} textAlign={"center"}>
          What are Scope 3 Emissions?
        </Typography>
        <Typography variant={"body1"}>
          Scope 3 emissions are the result of activities from assets not owned
          or controlled by your organization, but that the organization
          indirectly affects in both your upstream and downstream activities.
        </Typography>
        <Typography variant={"body1"}>
          Scope 3 emissions can be difficult to account for because there can be
          thousands of sources to catalog and estimate. However, because scope 3
          sources may represent most of an organization's GHG emissions, they
          often offer emissions reduction opportunities.
        </Typography>
      </LabsCard>
    </Grid>
    <Button component={Link} to="/plan" variant="outlined" color="primary">
      Back
    </Button>
  </Grid>
);

export default Scope3Info;
